import { observer } from 'mobx-react';
import React from 'react';
import { salesDetailsStore } from '../../store/salesDetailsStore';
import { IItemsReportParams } from '../../types/salesDetails';
import { allOptionsValue, defaultPagination } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import client from 'src/services/client';
import { IPagination } from 'src/types/main';
import { IProductV4, PRODUCT_TYPE } from 'src/types/product';
import CustomLazyPicker from 'src/view/components/Controls/Pickers/CustomLazyPicker/CustomLazyPicker';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types/index';
import SpinLoader from 'src/view/components/Controls/SpinLoader/SpinLoader';
import { ReportsBranchPicker } from 'src/view/screens/ReportsScreen/components/ReportsBranchPicker/ReportsBranchPicker';
import ReportsCalendar from 'src/view/screens/ReportsScreen/components/ReportsCalendar/ReportsCalendar';
import ReportsFranchiseePicker from 'src/view/screens/ReportsScreen/components/ReportsFranchiseePicker/ReportsFranchiseePicker';
import ReportContent from 'src/view/screens/ReportsScreen/containers/ReportContent/ReportContent';
import ReportHeader from 'src/view/screens/ReportsScreen/containers/ReportHeader/ReportHeader';
import { reportsStore } from 'src/view/screens/ReportsScreen/store/reportsStore';
import { appStore } from '~/mobx/appStore';
import logger from '~/services/logger';
import { REPORT_TYPE } from '~/view/screens/ReportsScreen/types/reports';

@observer
export default class ItemSales extends React.Component<{}, {}> {
  onSelectItem = (options: IPickerOption[]) => {
    salesDetailsStore.filters.items = options;
  };

  async componentDidMount() {
    if (!salesDetailsStore.reports.items.data) await this.buildReport();
  }

  fetchItems = async (page: number, searchValue: string = ''): Promise<IPagination<IProductV4>> => {
    try {
      const pagination: IPagination<IProductV4> = await client.get('v4/products', {
        params: { page, name: searchValue.toLowerCase(), is_delete: 0, types: [PRODUCT_TYPE.PRODUCT] },
      });
      return pagination;
    } catch (error: any) {
      logger.error({ error, place: 'ItemSales fetchItems' });
      return defaultPagination;
    }
  };

  buildReport = async () => {
    await salesDetailsStore.fetchItemsReport();
  };

  onExportReport = async () => {
    const params: IItemsReportParams = {
      ...reportsStore.getReportBuildParams(),
      items: salesDetailsStore.filters.items.some((option) => option.value === allOptionsValue)
        ? []
        : salesDetailsStore.filters.items.map((option) => option.value as number),
    };
    await salesDetailsStore.exportDetailsReportToXls(params, 'items', 'items', 'Item sales');
  };

  onCancel = () => {
    if (salesDetailsStore.cancelReportBuild.items) salesDetailsStore.cancelReportBuild.items('Cancelled');
  };

  render() {
    return (
      <div className="d-flex flex-column full-width flex-grow-1 mt-4">
        <ReportHeader onExportReport={this.onExportReport} onGenerateReport={this.buildReport} exportLoader={salesDetailsStore.reports.items.loading}>
          <ReportsCalendar startDate={reportsStore.filters.startDate} endDate={reportsStore.filters.endDate} />
          <CustomLazyPicker
            className="mr-2"
            inputClassName="report-header__picker"
            onFetch={this.fetchItems}
            selectedOptions={salesDetailsStore.filters.items}
            defaultOptions={[{ label: localeStore.t('all_items'), value: allOptionsValue }]}
            onSelect={this.onSelectItem}
            isSearchable
            isMulti
            small
            optionsDesc="items"
          />
          {appStore.isAddonsAvailable.franchise ? <ReportsFranchiseePicker /> : <ReportsBranchPicker />}
        </ReportHeader>
        <ReportContent
          actualReport={salesDetailsStore.reports.items.data}
          reportColumnName="Item"
          disabledRevenue
          className={'reports-disabled-revenue'}
          reportType={REPORT_TYPE.ITEMS}
        />
        {salesDetailsStore.reports.items.loading ? <SpinLoader onCancel={this.onCancel} /> : null}
      </div>
    );
  }
}
